import { JustRightHeightModal } from 'components/styled/scoped';
import { useTranslate } from '@tolgee/react';
import { Dispatch, SetStateAction, useCallback, useEffect } from 'react';
import type { ReactNode } from 'react';
import { css } from '@emotion/css';
import { HolderOutlined } from '@ant-design/icons';
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc';
import type { Column } from './tableCol';
import { cannotSortSelfColumn } from './tableCol';
import { useLatest } from 'ahooks';
import { cloneDeep } from 'lodash-es';

type PerfSortProps = {
  visible: boolean;
  onClose: () => void;
  setMeta: Dispatch<SetStateAction<Column[]>>;
  sortedColumns: Column[];
};

// className="leading-[20px] flex items-center text-[#515359] mb-[12px] cursor-grab

const SortableItem = SortableElement(({ value }: { value: Column }) => {
  const { t } = useTranslate();
  return (
    <div className="flex items-center mb-[12px] cursor-grab select-none">
      <HolderOutlined className="mr-[8px] text-[#999999]" />
      <span>{t(`ViewDashboard.${value.key}`)}</span>
    </div>
  );
});

const SortableBox = SortableContainer(({ children }: { children: ReactNode }) => {
  return <div className="px-[24px] my-[16px]">{children}</div>;
});

const PerfSort = (props: PerfSortProps) => {
  const { visible, onClose, sortedColumns, setMeta } = props;
  const sortedColumnsRef = useLatest(sortedColumns);
  const { t } = useTranslate();
  const excludedSortColumns = sortedColumns.filter((x) => !cannotSortSelfColumn.includes(x.key));
  const onSortEnd = useCallback(
    ({ oldIndex, newIndex }) => {
      const next = arrayMove(excludedSortColumns, oldIndex, newIndex).map((_, index) => {
        return {
          ..._,
          sortIndex: index,
        };
      });
      setMeta((pre) => {
        return pre.map((item) => {
          const target = next.find((_) => _.key === item.key);
          return target || item;
        });
      });
    },
    [setMeta, excludedSortColumns],
  );
  useEffect(() => {
    if (visible) {
      const sortedCount = sortedColumnsRef.current.filter((x) => x.sortIndex !== undefined).length;
      if (sortedCount === 0) {
        const keyMap = sortedColumnsRef.current.reduce((prev, curr) => {
          prev[curr.key] = curr.index;
          return prev;
        }, {} as Record<string, number>);
        setMeta((prev) => {
          const copy = cloneDeep(prev);
          copy.forEach((x) => {
            x.sortIndex = keyMap[x.key];
          });
          return copy;
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <JustRightHeightModal
      centered
      title={t('todo.自定义展示方案')}
      visible={visible}
      onCancel={onClose}
      width={584}
      footer={null}
      className={css`
        .ant-modal-body {
          padding: 0 !important;
          margin: 0 !important;
        }
      `}
    >
      <div className="bg-[#f0f7ff] h-[32px] px-[24px] flex items-center text-[#336fff] text-[14px]">
        {t('hangup_drag_tip')}
      </div>
      <SortableBox
        onSortEnd={onSortEnd}
        helperClass={css`
          z-index: 99999;
        `}
      >
        {excludedSortColumns?.map((each, index) => {
          return <SortableItem key={each.key} index={index} value={each} />;
        })}
      </SortableBox>
    </JustRightHeightModal>
  );
};

export default PerfSort;
